import { Button } from '@material-ui/core'
import * as Assert from 'assert'
import { signOut } from 'aws-amplify/auth'
import * as React from 'react'
import { useHistory } from 'react-router-dom'

import { PageWrapper } from '../../components/atoms/PageWrapper'
import { SectionTitle } from '../../components/atoms/SectionTittle'
import { TextInputEx } from '../../components/atoms/TextInputEx'
import { ConfirmDialog } from '../../components/molecules/ConfirmDialog'
import { useAppContext } from '../../services/app-context'
import { deleteMyself } from '../../services/user-services'
import { buttonsStyles } from '../../styles/ButtonsStyles'
import { containerStyles } from '../../styles/ContainerStyles'
import { invoke } from '../../utils/helper'

export const Profile: React.FC = () => {

    const styles = containerStyles()
    const btnStyles = buttonsStyles()
    const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false)
    const { user, setUser } = useAppContext()
    const history = useHistory()

    const initiateDeleteProfile = async () => {
        setConfirmDelete(true)
    }

    const deleteProfile = async () => {
        Assert.ok(user)

        setConfirmDelete(false)
        await invoke(async () => {
            try {
                await deleteMyself()
            } finally {
                try {
                    await signOut()
                } catch (e) {
                    // do nothing
                }

                setUser(undefined)
            }
        }, {
            operation: 'Deleting'
        })

        history.push('/')
    }

    return (
        <PageWrapper>
            <SectionTitle text="Min Profil"/>
            <div className={styles.innerAuthContainer}>

                <div className={styles.loginInputs}>
                    <TextInputEx
                        fullWidth
                        value={user?.email}
                        disabled
                        label="Email" />
                    <div style={{ display: 'flex' }}>
                        <TextInputEx
                            fullWidth
                            value={user?.firstName}
                            disabled
                            label="Fornavn"/>
                        <TextInputEx
                            fullWidth
                            value={user?.lastName}
                            disabled
                            label="Efternavn"/>
                    </div>

                </div>
                {confirmDelete && (
                    <ConfirmDialog
                        description="Er du sikker på, at du vil slette din profil?"
                        title="Slet Profil?"
                        onCancel={() => setConfirmDelete(false)}
                        onConfirm={deleteProfile} />
                )}
                <Button
                    disabled={!user}
                    onClick={initiateDeleteProfile}
                    className={btnStyles.deleteProfile}>
                    Slet Profil
                </Button>
            </div>

        </PageWrapper>
    )
}
